import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { X1DarkModeStateProvider } from "@x1-theme/X1DarkModeStateProvider";

import { router } from "./routes/router";

function App() {
  useEffect(() => {
    const preloader = document.getElementById("x1-preloader");
    if (preloader) {
      setTimeout(() => {
        preloader.classList.add("_8m3q");
        setTimeout(() => {
          preloader.remove();
        }, 600);
      }, 500);
    }
  }, []);

  return (
    <X1DarkModeStateProvider>
      <RouterProvider router={router} />
    </X1DarkModeStateProvider>
  );
}

export default App;
